import React from 'react';
// import {Link} from 'react-router-dom';

import classes from './TrdAdminFocusItem.css';

const trdAdminFocusItem = (props) => {
    return (
        <div className={classes.TrdAdminFocusItem}>
            <img
            className={classes.Image}
            src={props.image}
            alt="not found"/>
            <div className={classes.TextGroup}>
                <h2 className={classes.Name}>{props.name}</h2>
                <h2 className={classes.Variant}>{props.variant}</h2>
                <div className={classes.TextGrid}>
                    <p className={classes.Edition}><strong>LE {props.edition}</strong></p>
                    <p className={classes.Cost}><strong>Cost: ${props.cost}</strong></p>
                </div>
                <p className={classes.NumberAvailable}><strong>{props.numberAvail + '/' + props.orginallyAvailable} Available</strong></p>
                <p className={classes.Registrations}><strong>Registrations: {props.registrations}</strong></p>
                <div className={classes.ButtonGroup}>
                    <button className={classes.EditButton} onClick={props.editClicked}>EDIT</button>
                    <button className={classes.DeleteButton} onClick={props.deleteClicked}>DELETE</button>
                </div>
                
            </div>
        </div>
    )
}

export default trdAdminFocusItem;


// WEBPACK FOOTER //
// ./src/components/UI/TrdAdminFocus/TrdAdminFocusItem/TrdAdminFocusItem.js